import React from 'react'
import { IWorkplaceGroup } from '@api/types'
import MultiSelectComponent from './MultiSelectComponent'
import api from '@api'
import { Classes } from '@blueprintjs/core'
import { HighlightedText } from '..'
import css from './multiSelect.module.scss'
import { ItemProps } from './GenericSelectWithInfiniteScroll'

interface MultiWPGSelectProps {
  values: IWorkplaceGroup[] | undefined
  onChange: (items: IWorkplaceGroup[] | undefined) => void
  onCreate: (item: string) => Promise<IWorkplaceGroup>
  onClear: () => void
}

export function WorkplaceGroupItem({ type, data, refItem, query }: ItemProps<IWorkplaceGroup>) {
  if (type === 'skeleton') {
    return (
      <div className="flex items-center py-1" style={{ minWidth: 300 }}>
        <div className="ml-2">
          <span className={Classes.SKELETON}>tag name</span>
        </div>
      </div>
    )
  }

  const { name } = data as IWorkplaceGroup

  return (
    <div ref={refItem} className="flex items-center py-1 truncate">
      <div className="ml-2 font-medium truncate">
        <HighlightedText query={query} text={name} />
      </div>
    </div>
  )
}

export default function MultiWorkGroupSelect({
  values,
  onChange,
  onCreate,
  onClear,
}: MultiWPGSelectProps) {
  return (
    <MultiSelectComponent
      title=""
      customClass={{ multiCustomClass: css.multiSelectCustomClass }}
      multi
      values={values || []}
      list={api.workplaceGroup.search}
      icon={null}
      itemRenderer={WorkplaceGroupItem}
      onChange={onChange}
      canCreate
      onCreate={onCreate}
      onClear={onClear}
    />
  )
}
